import { css } from '@emotion/css'
import { colors, fontWeight, shorthandHelper, spacing } from '@offerzen/pinata'

const styles = {
  card: css({
    display: 'flex',
    padding: shorthandHelper([spacing.default, spacing.large]),
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: spacing.large,
    gap: spacing.default,
  }),

  subheading: css({
    fontWeight: fontWeight.semiBold,
    color: colors.blackPearl,
  }),
}

export default styles
